import { openMessageWarning } from '../../components/common/Message/openMessageWarning';
import i18n from '../../languages/i18n';

export const normFileWithValidation = ({
  e,
  fileSize = 2 * 1024 * 1024,
  oldFiles = [],
}) => {
  if (Array.isArray(e)) {
    return e;
  }

  const files = e?.target?.files || e?.currentTarget?.files;

  if (!files || files.length === 0) {
    return oldFiles;
  }

  const newFiles = Array.from(files)
    .map(file => {
      // Validate file size (ví dụ: max 2MB)
      const isLt2M = file.size / fileSize < 2;
      if (!isLt2M) {
        openMessageWarning({
          content: `${i18n.t('Ảnh phải nhỏ hơn')} ${fileSize / (1024 * 1024)}MB!`,
        });
        return null;
      }

      // Validate file type
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        openMessageWarning({
          content: i18n.t('Only image files are accepted (.png, .jpg, .jpeg)'),
        });
        return null;
      }

      const preview = URL.createObjectURL(file);

      return {
        uid: `${file.name.replace(/[^a-z0-9]/gi, '')}_${Date.now()}`,
        name: file.name,
        status: 'done',
        originFileObj: file,
        url: preview,
      };
    })
    .filter(Boolean);

  // Kết hợp file cũ + file mới
  return [...oldFiles, ...newFiles];
};
